let pop_name, pop_address, pop_phone, pop_flag_newPatient, pop_website, pop_types_patients
let pop_langs, pop_insurances, pop_providers, pop_display;
let pop_clickme;
let pop_clickable;
let pop_hospital;
let markerL;//a marker created by geolocating
const N_PROVIDERS = 31


function setPopVars(feature) {
    let attrs = feature.properties;
    pop_name = attrs.Practice_name;
    pop_address = `${attrs.Address1 == undefined ? '' : attrs.Address1}, 
    ${attrs.City == undefined ? '' : attrs.City}, 
    ${attrs.State == undefined ? '' : attrs.State}, 
    ${attrs.Zip == undefined ? '' : attrs.Zip}`
    pop_phone = attrs.practice_phone;
    pop_hospital = attrs.delivering_hospital == undefined? "" : attrs.delivering_hospital.replace("WIH", "Women & Infants Hospital");
    pop_website = attrs.practice_website == undefined? undefined: (attrs.practice_website.includes('http')? attrs.practice_website:undefined);
    pop_clickme = pop_website == undefined ? 'Not Available' : 'Click Me';
    pop_clickable = pop_website == undefined ? 'disabled' : '';
    pop_flag_newPatient = attrs.acceptingnewpatients;
    pop_display = pop_flag_newPatient.toLowerCase() == 'yes' ? '' : 'd-none';
    pop_types_patients = pop_display == 'd-none' ? '' : `${attrs.accepting_new_type}${attrs.accepting_new_type_other_descrip && attrs.accepting_new_type_other_descrip > 1 ? `, ${attrs.accepting_new_type_other_descrip}` : ''}`;
    pop_langs = `${attrs.lang_english == 'Yes' ? 'English' : ''}${attrs.lang_spanish == 'Yes' ? ', Spanish' : ''}${attrs.lang_portuguese == 'Yes' ? ", Portuguese" : ''}${attrs.lang_other == 'Yes' ? `, ${attrs.language_other_text}` : ''}`;
    pop_insurances = `${attrs.ins_bluecross == 'Yes' ? 'Blue Cross' : ''}${attrs.ins_united == "Yes" ? ", United" : ''}${attrs.ins_neighborhood == "Yes" ? ", Neighborhood" : ''}${attrs.ins_tufts == "Yes" ? ", Tufts" : ''}${attrs.ins_medicaid == "Yes" ? ", Medicaid" : ''}${attrs.ins_other == "Yes" ? `, ${attrs.insurance_other_text}` : ''}`;
    pop_providers = (() => {
        let providers_arr = [];
        for (let i = 1; i <= N_PROVIDERS; i++) {
            attrs[`provider${i}`] && attrs[`provider${i}`].length > 2 ? providers_arr.push(attrs[`provider${i}`]) : {}
        }
        ;
        return providers_arr.join('<br>');
    })();
    let popupHTML = `<h5>${pop_name}</h5><hr>
        <b>Address:</b> ${pop_address}<br>
        <b>Phone:</b> ${pop_phone}<br>
        <b>Website:</b> <a href="${pop_website}" class="btn p-0 m-0 ${pop_clickable}" target="_blank" style="font-size:0.76rem">${pop_clickme}</a><br><br>
        <b>Delivery Hospital: </b>${pop_hospital}<br><br>
        <b>New Patients Accepted? </b>${pop_flag_newPatient}<br>
        <span class="${pop_display}"><b>Types of New Patients: </b>${pop_types_patients}<br></span><br>
        <b>Languages Spoken: </b>${pop_langs}<br><br>
        <b>Insurances Accepted: </b>${pop_insurances}<br><br>
        <b>Providers:</b><br>
        ${pop_providers}`
    return popupHTML;
}

const mapURL = "https://services.arcgis.com/8veDRDlhXWywYP3S/ArcGIS/rest/services/ObstetricProviders2020_1/FeatureServer/0"
//create an icon for providers
let iconP = L.AwesomeMarkers.icon({
    icon: "clinic-medical",
    prefix: "fa",
    spin: false,
    markerColor: "blue"


});
//create an icon for successful locating
let iconL = L.AwesomeMarkers.icon({
    icon: "map-marker-alt",
    spin: false,
    prefix: "fa",
    iconColor: "white",
    markerColor: "orange"


});

//set up basemap
let map = L.map('map',
    {
        center: [41.825606, -71.407919],
        zoom: 13,
    });
const mapLink = '<a href="https://openstreetmap.org">OpenStreetMap</a>';
const userLink = '<a href="mailto:guixing_wei@brown.edu">Guixing Wei@S4</a>';
let attribution = '&copy;' + mapLink + ' Developer' + '| &copy;' + userLink + '';
L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
    attribution: attribution,
}).addTo(map);

//load wfs service
let vLayer = L.esri.featureLayer({
    url: mapURL,
    pointToLayer: function (geojson, latlng) {
        return L.marker(latlng, {icon: iconP})
    },
    onEachFeature: function (feature, layer) {
        let content = setPopVars(feature);
        layer.bindPopup(content).addTo(map);
    }

}).addTo(map);

//map locate
map.locate({
    setView: false,
    maxZoom: 13,
    enableHighAccuracy: true,
});
map.addEventListener('locationfound', function (e) {
    map.panTo(e.latlng, {animate: false});
    markerL = new L.marker(e.latlng,
        {
            icon: iconL,
            bounceOnAdd: true,
            bounceOnAddOptions: {duration: 1500}
        })
        .bindPopup("You are here!")
        .addTo(map);
    markerL.openPopup();


});
map.addEventListener('locationerror', function (e) {
    //alert("Unable to locate; please enable your browser's location service!");
});

//add geocoder contorl
let geocode_point;
const southWest = L.latLng(41.363407, -71.829872),
    northEast = L.latLng(42.006935, -71.250924),
    bounds = L.latLngBounds(southWest, northEast);
let geocoder = L.esri.Geocoding.geosearch({
    position: 'topleft',
    searchBounds: bounds,
    title: "Put in your address to find practices near you",
    placeHolder: "Address search",
    zoomToResult: false
}).addTo(map);
let geocoder_result = L.layerGroup().addTo(map);
geocoder.addEventListener('results', results => {
    geocoder_result.clearLayers();
    if (markerL != undefined) {
        map.removeLayer(markerL);
    }
    ;
    result_1st = results.results[0].latlng;
    geocoder_result.addLayer(L.marker(result_1st, {riseOnHover: true, icon: iconL}));
    let nearest_points = get_nearest(result_1st, map, vLayer, 8);
    //console.log(nearest_points);
    let nearest_bounds = L.latLngBounds(nearest_points);
    map.fitBounds(nearest_bounds);
    map.flyTo(result_1st);

});


function get_nearest(point, map, feature_layer, factor = 5) {
    let arr_points = [];
    feature_layer.eachFeature(function (layer) {
        let feature = layer.feature;
        let fid_dis_point = {};
        //console.log(feature);
        let coor = {lat: feature.geometry.coordinates[1], lng: feature.geometry.coordinates[0]};
        let point_current = L.latLng(coor);
        let id = feature.id;
        let dis = map.distance(point_current, point);
        fid_dis_point.fid = id;
        fid_dis_point.dis = dis;
        fid_dis_point.point = point_current;
        arr_points.push(fid_dis_point);
    });
    arr_points.sort((a, b) => (a.dis > b.dis) ? 1 : -1);
    let top3 = arr_points.slice(0, factor);
    let bounds = [point];
    let fitbounds = [];
    top3.forEach(function (element) {
        bounds.push(element.point);
    });
    bounds.forEach(function (x) {
        fitbounds.push(Object.values(x));
    });
    return fitbounds;
};
let clear_btn = document.getElementById("clear-btn");
clear_btn.addEventListener("click", function () {
    let checks = document.querySelectorAll(".form-check-input");
    checks.forEach(function (checkbox) {
        checkbox.checked = false;
    });
    vLayer.setWhere("1=1");

})
let query_btn = document.getElementById("query-btn");
query_btn.addEventListener("click", function () {
    let checks = document.querySelectorAll(".form-check-input");
    checks = Array.from(checks);
    let checks_checked = checks.filter(el => el.checked && el.type == "checkbox");
    let radio_checked = checks.filter(el => el.checked && el.type == "radio" && el.name == "patient-radio"); //accept new or not
    let radio_hospital = checks.filter(el => el.checked && el.type == "radio" && el.name == "hospital");

    let query_keys = checks_checked.map(el => el.value);
    let where_str = '1=1';
    if (query_keys.length > 0) {
        query_keys.forEach(key => {
             where_str += ` AND ${key}='Yes'`
        });
    }

    if (radio_checked.length == 1) {
        let radio_val = radio_checked[0].value;
        if (radio_val == 'Yes') {
            where_str += ` AND (acceptingnewpatients = '${radio_val}' OR acceptingnewpatients = 'Con')`;
        }
        else {
        where_str += ` AND acceptingnewpatients = '${radio_val}'`;}

    } ;

    if (radio_hospital.length == 1){
        let radio_val = radio_hospital[0].value;
        where_str += ` AND delivering_hospital LIKE '%${radio_val}%'`
    }
    //console.log(where_str);
    vLayer.setWhere(where_str);


})








